import { Catalog } from '../api/CataloguesAPI';

/** Public catalogues chosen as media-rich examples from different brands. */
export const ONBOARDING_EXAMPLE_CATALOGUE_UUIDS = [
  "2bbefd42-4178-4c40-882b-f738ec1a7236", // Agnieszka Światły — 2025 Collection EUR
  "da0a2f29-03b7-408b-892c-4300e112236d", // Mari Lill — Kolekcja City Lights 2025
] as const;

export const exampleCatalogPillLabel = (
  catalog: Pick<Catalog, 'name' | 'designer' | 'storeName'>
): string => {
  const designer = catalog.designer?.trim() || '';
  const store = catalog.storeName?.trim() || '';
  const brand = designer && store && designer !== store
    ? `${designer} (${store})`
    : designer || store;
  if (brand && catalog.name) {
    return `${brand} — ${catalog.name}`;
  }
  return catalog.name || brand;
};
